var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.627,
    height: 30.391,
    viewBox: "0 0 22.627 30.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard_1_",
    "data-name": "clipboard (1)",
    transform: "translate(-0.243 -0.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55739",
    "data-name": "Group 55739",
    transform: "translate(0.243 0.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55738",
    "data-name": "Group 55738",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87459",
    "data-name": "Path 87459",
    d: "M145.728,2.3H143.5a.624.624,0,0,1-.585-.468A2.263,2.263,0,0,0,140.617,0a2.3,2.3,0,0,0-2.3,1.873.585.585,0,0,1-.585.429h-2.146v3.9h10.143Z",
    transform: "translate(-129.343 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87460",
    "data-name": "Path 87460",
    d: "M74.615,86.089V63.736a1.6,1.6,0,0,0-1.6-1.6q-.061,0-.121,0H69.543v1.99c0,.312-.2.741-.507.741H57.528c-.312,0-.468-.429-.468-.741V62.137H53.7a1.6,1.6,0,0,0-1.712,1.478q0,.061,0,.121V86.09A1.755,1.755,0,0,0,53.7,87.884H72.9a1.756,1.756,0,0,0,1.716-1.794ZM60.142,80.94,57.1,83.788a.546.546,0,0,1-.39.2.624.624,0,0,1-.429-.2l-1.6-1.638a.594.594,0,0,1,.858-.819l1.17,1.248,2.653-2.5a.585.585,0,0,1,.78.858Zm0-6.242h0L57.1,77.546a.546.546,0,0,1-.39.2.624.624,0,0,1-.429-.2l-1.6-1.638a.594.594,0,0,1,.858-.819l1.17,1.248,2.653-2.5a.585.585,0,0,1,.78.858Zm0-6.242L57.1,71.3a.546.546,0,0,1-.39.2.624.624,0,0,1-.429-.2l-1.6-1.638a.594.594,0,0,1,.858-.819l1.17,1.248,2.653-2.5a.585.585,0,0,1,.78.858ZM71.494,83.2H62.521a.585.585,0,1,1,0-1.17h8.972a.585.585,0,0,1,0,1.17Zm0-6.242H62.521a.585.585,0,1,1,0-1.17h8.972a.585.585,0,0,1,0,1.17Zm0-6.242H62.521a.585.585,0,1,1,0-1.17h8.972a.585.585,0,0,1,0,1.17Z",
    transform: "translate(-51.988 -57.493)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.415cbb99beef02ac43a8b0ae6e7f7e42.svg";
export { ForwardRef as ReactComponent };